/* eslint-disable react/prop-types */
import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { ReactComponent as MegaphoneIcon } from '../../../assets/svg/icons/MegaphoneIcon.svg';
import pushGA4AnnouncementEvent from '../../../utilities/ga4-announcement-events';

const useStyles = makeStyles((theme: Theme) => {
    return createStyles({
        tooltip: {
            '&&': {
                color: '#fff',
                backgroundColor: '#000',
                width: theme.typography.pxToRem(150),
                fontSize: theme.typography.pxToRem(14),
                marginBottom: theme.spacing(0.8),
                textAlign: 'center'
            }
        },
        arrow: {
            '&&': {
                color: '#000'
            }
        },
        popper: {
            color: '#000'
        }
    });
});
const AnnouncementIcon: React.FC<AnnouncementIconProps> = ({ hasUnread = false, panelOpen = false, onClick = () => {} }) => {
    const ai = 'announcement-icon';

    const handleClick = () => {
        pushGA4AnnouncementEvent('megaphone_icon_click', {
            panelAction: panelOpen ? 'closed' : 'opened',
            hadUnreadDot: hasUnread
        });
        onClick();
    };

    return (
        <Tooltip classes={useStyles()} placement="top" arrow enterTouchDelay={0} leaveTouchDelay={5000} title="Announcements">
            <button
                type="button"
                className={`${ai}__bell-btn`}
                onClick={handleClick}
                aria-label={`What's New${!hasUnread ? ', have unread notifications' : ''}`}
                aria-expanded={panelOpen}
                aria-haspopup="true"
            >
                <MegaphoneIcon />
                {hasUnread && <span className={`${ai}__badge`} aria-hidden="true" />}
            </button>
        </Tooltip>
    );
};
export default React.memo(AnnouncementIcon);
